module.exports = __webpack_public_path__ + "img/icon-cupom-marketing.40f8b591.svg";